import React from 'react';
import PasswordInput from '../Fields/PasswordInput';
import SubmitButton from '../Fields/SubmitButton';

let Quote = require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const MyHomeLetRegistration = React.createClass({
    getInitialState() {
        return {
            showSuccessMessage : false,
            showMismatchError : false,
            show500Error : false,
            show409Error : false,
            passwordFieldValid: false,
        };
    },

    showSuccessMessage() {
        this.setState({
            showSuccessMessage : true
        });
    },

    show500Error() {
        this.setState({
            show500Error : true
        });
    },

    show409Error() {
        this.setState({
            show409Error : true
        });
    },

    /**
     * callback function: sets bothFieldsValid true or false from child
     * components. Stops POST events for MHL registration unless valid.
     *
     * @param event
     */
    validationCallback(event) {
        this.setState({ passwordFieldValid: event });
    },

    submit() {
        let email = Quote.getCurrentAnswer('email_address');
        let password = this.refs.password.state.activeValue;
        let confirm_password = this.refs.confirm_password.state.activeValue;
        let dob = Quote.getCurrentAnswer('date_of_birth_at');
        let _this = this;

        if (this.state.passwordFieldValid === true && password === confirm_password) {
            $.ajax({
                type: 'POST',
                async : false,
                data: {
                    email,
                    password,
                    dob,
                },
                url: Config.mhl.registration.url,
                success : function(results, textStatus, xhr) {
                    switch (xhr.status) {
                        case 201:
                            _this.showSuccessMessage();
                            break;
                    }
                    this.setState({
                        show500Error: false,
                        show409Error: false,
                    });
                },
                error : function(results, textStatus, xhr) {
                    switch (xhr.status) {
                        case 500:
                            _this.show500Error();
                            break;
                        case 409:
                            _this.show409Error();
                            break;
                    }
                }
            });
        }
    },

    render() {
        return (
            <div className="mhl-block">
                {this.state.showMissingFieldsError ?
                    <div>
                        <p>Please correct the following error(s):</p>
                        <ul>
                            <li>Password must be at least 8 characters in length</li>
                            <li>Password must contain at least one uppercase letter</li>
                            <li>Password must contain at least one digit character</li>
                        </ul>
                    </div>
                : null}
                {this.state.showMismatchError ?
                    <div>
                        <p>Please correct the following error(s):</p>
                        <ul>
                            <li>Passwords are not the same</li>
                        </ul>
                    </div>
                : null}

                {this.state.show500Error ?
                    <div>
                        <p>Sorry, we encountered an error when trying to register a My HomeLet account for you. Please call us on 0800 038 4574</p>
                    </div>
                : null}

                {this.state.show409Error ?
                    <div>
                        <p>You are already registered for My HomeLet - please log in to your account to see yor quotes: <a href="https://homelet.co.uk/my-homelet/login" target="_blank">https://homelet.co.uk/my-homelet/login</a></p>
                    </div>
                : null}

                {this.state.showSuccessMessage ?
                    <div>
                        <p>Thank you for registering for My HomeLet. For security, we&rsquo;ve sent you an email to validate your email address.</p>
                        <p>Please check your inbox and click the secure link in the email to activate your My HomeLet account.</p>
                    </div>
                :
                <div>
                    <PasswordInput
                        question="Password"
                        fieldName="mhl_password"
                        ref="password"
                        maxLength={50}
                        helpText=""
                        validationCallback={this.validationCallback}
                     />

                    <PasswordInput
                        question="Confirm Password"
                        fieldName="mhl_confirm_password"
                        ref="confirm_password"
                        maxLength={50}
                        helpText=""
                        checkMatch={true}
                        checkAgainst="mhl_password"
                     />

                    <SubmitButton
                        backLink={null}
                        saveForLater={null}
                        onClick={this.submit}
                        label="Submit"
                    />
                </div> }
            </div>
        );
    }
});

export default MyHomeLetRegistration;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/MyHomeLetRegistration.js
 **/